// @ts-nocheck
// Vuex module の段階的 TypeScript 化（まずはファイル移管。詳細な型は後続対応）
const state = {
  liveCanvasElm: null,
}

const mutations = {
  setLiveCanvasElm(state, liveCanvasElm) {
    state.liveCanvasElm = liveCanvasElm
  },
}

const getters = {
  liveCanvasElm(state) {
    return state.liveCanvasElm
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
